import React from 'react';
import OutsourcingHeroSection from '../Components/Outsourcing/OutsourcingHeroSection.jsx';
import BussinessOutsource from '../Components/Outsourcing/BussinessOutsource.jsx';
import ProfessionalSupportServices from '../Components/Outsourcing/ProfessionalSupportServices.jsx';
const Outsourcing = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/40 pb-16">
        <OutsourcingHeroSection />
        <BussinessOutsource/>
        <ProfessionalSupportServices />
      {/* <div className="max-w-7xl mx-auto px-6 pt-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center px-6 py-3 bg-[#1719A8]/90 backdrop-blur-md border border-[#1719A8]/60 rounded-full mb-6 shadow-lg">
            <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
            <span className="text-white font-semibold uppercase tracking-wider text-sm">
              Outsourcing Solutions
            </span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-black mb-8 tracking-tight text-slate-900">
            Global Outsourcing
            <span className="block bg-gradient-to-r from-[#1719A8] to-[#D96F2B] bg-clip-text text-transparent">
              & Staff Augmentation
            </span>
          </h1>

          <p className="text-xl leading-relaxed max-w-3xl mx-auto text-slate-600 mb-12">
            Scale your team with our world-class outsourcing services, staff augmentation,
            and dedicated development teams for accelerated project delivery.
          </p>

          <div className="bg-white/60 backdrop-blur-xl rounded-3xl border border-white/30 p-12 shadow-2xl">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">Coming Soon</h2>
            <p className="text-lg text-slate-600 mb-8">
              Our comprehensive outsourcing services page is under development.
              We're preparing detailed information about our BPO, KPO, staff augmentation,
              and dedicated team solutions.
            </p>
          </div>
        </div>
      </div> */}
    </main>
  );
};

export default Outsourcing;
